import { WidgetPlatform } from 'constants/widgets';
import { StateCreator } from 'zustand';

interface SelectedWidgetPlatformState {
    selectedWidgetPlatform: WidgetPlatform;
    setSelectedWidgetPlatform: (platform: WidgetPlatform) => void;
}

const createSelectedWidgetPlatformSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    SelectedWidgetPlatformState
> = set => ({
    selectedWidgetPlatform: WidgetPlatform.wordpress,
    setSelectedWidgetPlatform: (platform: WidgetPlatform) =>
        set({
            selectedWidgetPlatform: platform,
        }),
});

export { createSelectedWidgetPlatformSlice };
export type { SelectedWidgetPlatformState };
